<template>
  <div class="hairdressing-info-wrapper">
    <div class="head" style="padding: 0px">
      <div style="display:flex;align-items:center;margin-top:0.5%">
        <i style="font-size:1.5rem;margin-right:10px;" class="iconfont icon-bijibennotebook43"></i>
        <span id="fontF">治疗信息管理</span>
      </div>
      <div class="btn-wrap" v-acl="['export_AddMethods']">
        <button class="btn" @click="addTreatmentItems" style="font-size: 14px;">编辑治疗项目模板</button>
      </div>
    </div>
    <div class="parameter-number">
      <div class="text">编号</div>
      <div class="numbers-content" ref="numbersContent">
        <div class="numbers-box" ref="numbersBox" :class="{showSlide: isShowParNumsBtn}">
          <div
            class="to-left-btn iconfont"
            v-show="isShowParNumsBtn"
            @mousedown="parNumsMoveToLeft"
          >&#xe61ba;</div>
          <div class="num-item-wrap" ref="numItemWrap">
            <div class="num-item-box" ref="numItemBox">
              <div
                class="num-item"
                :class="{active: item.isActive}"
                v-for="(item, index) in parNumsList"
                :key="index"
                @click="selectParNum(item)"
                @dblclick="modifyParNum"
                @contextmenu.prevent="deleteParNum(item,index)"
              >{{item.number}}</div>
            </div>
          </div>
          <div
            class="to-right-btn iconfont"
            v-show="isShowParNumsBtn"
            @mousedown="parNumsMoveToRight"
          >&#xe6e8a;</div>
          <div v-show="isShowAddParmNum" class="add-btn iconfont" @click="addParNum">&#xe640;</div>
        </div>
      </div>
      <!-- <div class="text"></div> -->

    </div>
    <div class="quickSearch"> 
      <div class="quickSearchLine"> 
        <!-- <el-switch v-model="quickInputModel" active-text="开启快捷输入" inactive-text="关闭"> </el-switch> -->
        <div style="margin:10px 10px 10px 20px; width:100px; font-size:14px; font-weight:600" class="mirrorText" id="fontM">快捷输入
          <el-popover
            placement="top-start"
            title="帮助"
            width="240"
            trigger="hover"
            content="可以输入治疗设备、方法、模块、药物等文字、拼音、拼音首字母等，快捷检索项目信息"
          >
            <i slot="reference" class="iconfont icon-bangzhu popTips"></i>
          </el-popover>
        </div>
        <el-autocomplete
          id="diagnose-result-input"
          class="inline-input"
          v-model="quickSelectedItem"
          :fetch-suggestions="queryItem"
          clearable
          placeholder="----输入文字、拼音、拼音首字母等----"
          :trigger-on-focus="false"
          @select="selectItem"
          @blur="saveQuickSelection(false, '', 'yes')"
          @focus="haveSelectedItem = false"
          size="small"
          style="width: 80%;"
        ></el-autocomplete>
      </div>           
    </div>

    <div  class="type-tab-wrap" v-show="hairdressingInfoData.selectedParNum && typeTabList.length>1">
      <div class="type-tab" :class="{on: isShowSlide}">
        <div
          class="slide-btn iconfont"
          @mousedown="typeTabMoveToLeft"
          style="border-right: 1px solid #e0e0e0"
        >&#xe60a;</div>
        <div class="center-box">
          <div class="tab-content" ref="tabContent" style="left: 0;">
            <div
              class="tab-item"
              :class="{active: item.isActive, disabled: hairdressingInfoData.typeTabDisabled}"
              v-for="(item, index) in typeTabList"
              :key="index"
              @click="selectTypeTab(item)"
            >{{item.item_name}}</div>
          </div>
        </div>
        <div
          class="slide-btn iconfont"
          @mousedown="typeTabMoveToRight"
          style="border-left: 1px solid #e0e0e0"
        >&#xe61a;</div>
      </div>
      <div class="type-tab" :class="{on: !isShowSlide}">
        <div class="center-box">
          <div class="tab-content" style="left: 0;" ref="tabContent2">
            <div
              class="tab-item"
              :class="{active: item.isActive, disabled: hairdressingInfoData.typeTabDisabled}"
              v-for="(item, index) in typeTabList"
              :key="index"
              @click="selectTypeTab(item)"
            >{{item.item_name}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <CommonHairdressingForm
        v-show="hairdressingInfoData.selectedTypeTabData"
        v-if="refreshControl"
      />
    </div>

    <addTherapies
      :therapiesStatus='therapiesStatus'
      @setTherapiesStatus="setTherapiesStatus()"
    ></addTherapies>
    <CommonAddParameterNumber @createEmptyParNum="createEmptyParNum" :parNumsList="parNumsList"/>
    <CommonModifyParameterNumber :parNumsList="parNumsList"/>
  </div>
</template>

<script>
  import CommonHairdressingForm from './CommonHairdressingForm';
  import addTherepiesMixins from '../utils/addTherepiesMixins';
  import CommonAddParameterNumber from './CommonAddParameterNumber.vue';
  import CommonModifyParameterNumber from './CommonModifyParameterNumber.vue';
  import removeCosmetologyTreatDetail from "../gql/removeCosmetologyTreatDetail.gql";
  import gql from 'graphql-tag';
  import PinyinMatch from 'pinyin-match';

  export default {
    components: {
      CommonHairdressingForm,
      CommonAddParameterNumber,
      CommonModifyParameterNumber,
    },
    mixins:[addTherepiesMixins],
    inject: {
      commonData: ['commonData'],
    },
    
    provide() {
      const quickInputModel_ = ()=>{
        return {
          data:{
            value: this.quickInputModel
          }
        }
      }
      return {
        hairdressingInfoData: this.hairdressingInfoData,
        addParNumData: this.addParNumData,
        createEmptyParNum: this.createEmptyParNum,
        modifyParNumData: this.modifyParNumData,
        quickInputModel: () => this.$data.quickInputModel,
      }
    },
    
    data() {
      return {
        typeTabList: [],
        // 美容项目选项列表dom元素
        typeTabDom: null,
        typeTabDom2: null,
        timer: null,
        // 美容项目选项列表dom元素每次移动的速度  单位:像素
        moveVelocity: 10,
        // 是否显示滑动按钮布局
        isShowSlide: false,
        // 重置控制按钮
        refreshControl: true,
        hairdressingInfoData: {
          // 美容项目选项是否禁止点击
          typeTabDisabled: false,
          selectedTypeTabData: null,
          // 选中的参数编号数据
          selectedParNum: null,
          // 快捷输入时，选中的项目全部信息
          quickSelectedItem: null,

        },
        addParNumData: {
          isShowDialog: false,
          detail_title: '',
        },
        modifyParNumData: {
          isShowDialog: false,
        },
        // 是否显示参数编号滑动按钮布局
        isShowAddParmNum:true,
        isShowParNumsBtn: false,
        // 参数编号dom元素
        parNumsDom: null,
        parNumsDom2: null,
        parNumsDom3: null,
        parNumsDom4: null,
        // 参数编号dom元素可移动的距离
        parNumsDomMoveMax: 0,
        timer2: null,
        // 参数编号数据列表
        parNumsList: [
          /*{
            number: '1',
            isActive: false,
          },
          {
            number: '2',
            isActive: false,
          },*/
        ],
        typeTabDomMoveMax: 0,
        // 治疗信息录入,快捷模式（输入框内键入拼音首字母或关键字，匹配）
        quickInputModel: false,
        // 已快捷选择治疗项目
        haveSelectedItem: false,
        // 已快捷选择治疗项目
        quickSelectedItem: "",
        seperator : '--',
      };
    },
    
    watch: {
      // async 'commonData.cosmetologyTree'() {
      // },
      // async 'quickInputModel'(val){
      //   console.log("quickInputModel vale changed:",this.quickInputModel);
      // }
    },
    
    methods: {
      // 美容项目选项列表向左移动 按下
      typeTabMoveToLeft(e) {
        this.timer = setInterval(() => {
          this.typeTabDom.style.left = (Math.min(0, this.typeTabDom.offsetLeft + this.moveVelocity)) + 'px';
        }, 10)
      },
      // 美容项目选项列表向右移动 按下
      typeTabMoveToRight(e) {
        this.timer = setInterval(() => {
          this.typeTabDom.style.left = (Math.max(-this.typeTabDomMoveMax, this.typeTabDom.offsetLeft -
            this.moveVelocity)) + 'px';
        }, 10)
      },
      // 参数编号选项列表向左移动 按下
      parNumsMoveToLeft() {
        this.timer2 = setInterval(() => {
          this.parNumsDom4.style.left = (Math.min(0, this.parNumsDom4.offsetLeft + this.moveVelocity)) + 'px';
        }, 10)
      },
      // 参数编号选项列表向右移动 按下
      parNumsMoveToRight() {
        this.timer2 = setInterval(() => {
          this.parNumsDom4.style.left = (Math.max(-this.parNumsDomMoveMax, this.parNumsDom4.offsetLeft -
            this.moveVelocity)) + 'px';
        }, 10)
      },

      // 切换美容/治疗项目
      selectTypeTab(item) {
        // console.log("selectTypeTab,item:", item);
        this.commonData.isClickAddSign = false ;
        // 将原item 设置为isActive = false
        if (this.hairdressingInfoData.selectedTypeTabData) {
          this.hairdressingInfoData.selectedTypeTabData.isActive = false;
        }
        // 将新item 设置为isActive = true
        item.isActive = true;
        this.hairdressingInfoData.selectedTypeTabData = item;
        // 切换Tab后，将快捷输入框内容清空
        this.quickSelectedItem = "";
        this.hairdressingInfoData.quickSelectedItem = null;

        // 向子组件 CommonHairdressingForm 发射信号
        this.$root.$emit('selectTypeTab');
      },

      async deleteParNum(item,index){
        if (this.parNumsList.length > 1){
      /*     let annotations = await konvaDraw.getImageAnnotation();
          let mutations;
          let variabless;*/
            this.$confirm('此操作将永久删除该编号, 是否继续?', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning',
                center: true
            }).then(async() => {

                if (item.id){
                    this.removeData(item.id)
                }
                this.parNumsList.splice(index,1)
                this.$message.success("参数编号已刪除");
                // console.log(this.parNumsList && this.parNumsList.length>0);
                if (this.parNumsList && this.parNumsList.length>0){
                    this.selectParNum(this.parNumsList[0])
                }
                // console.log("After deleteParNum, parNumsList:", this.parNumsList);
                this.$root.$emit('refreshCosmetParaDigest');
                //
                /*    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });*/
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        } else {
            this.$message.error("至少保留一个参数编号");
        }

      },

      // 删除参数编号
      async removeData(removeId) {
          try {
              let res = await this.$apollo.mutate({
                  mutation: removeCosmetologyTreatDetail,
                  variables: {
                      id: removeId
                  },
                  fetchPolicy: "no-cache"
              });

              if (res.data.removeCosmetologyTreatDetail) {
                console.log(1)
              } else {
                  this.$message.error("删除失败");
              }
          } catch (error) {
              console.log(error);
          }
      },
      // 选择了参数编号
      selectParNum(item) {
        // console.log("In CommonHairdressingInfo, selectParNum(), item:",item);
        // console.log("parNumsList:", this.parNumsList);
        if (this.hairdressingInfoData.selectedParNum) {
          this.hairdressingInfoData.selectedParNum.isActive = false;
        }
        item.isActive = true;
        this.hairdressingInfoData.selectedParNum = item;
        // 显示详细信息
        this.showParNumDetail(item);
      },
      // 显示参数编号的详细信息
      showParNumDetail(item) {
        // console.log("In CommonHairdressingInfo, showParNumDetail(), item:",item);
        // console.log("typeTabList:", this.typeTabList);
        if (item.id) {
          if (this.hairdressingInfoData.selectedTypeTabData) {
            this.hairdressingInfoData.selectedTypeTabData.isActive = false;
          }
          for (const typeTab of this.typeTabList) {
            
            if (typeTab.id === item.item_id) {
              typeTab.isActive = true;
              this.hairdressingInfoData.selectedTypeTabData = typeTab;

              break;
            }
          }
        
          this.$root.$emit('selectTypeTab');
        } else {

        if (this.hairdressingInfoData.selectedTypeTabData == null){
          if  (this.typeTabList.length>0){
    
            this.commonData.isClickAddSign = false ;
            if (this.hairdressingInfoData.selectedTypeTabData) {
              this.hairdressingInfoData.selectedTypeTabData.isActive = false;
            }
            this.typeTabList[0].isActive = true;
            this.hairdressingInfoData.selectedTypeTabData = this.typeTabList[0];
            this.$root.$emit('selectTypeTab');
          }
        }else {
            this.$root.$emit('selectTypeTab');
        }
         /* if (this.hairdressingInfoData.selectedTypeTabData) {
            this.hairdressingInfoData.selectedTypeTabData.isActive = false;
            this.hairdressingInfoData.selectedTypeTabData = null;
          }*/
        }
      },
      // 判断是否需要左右滚动
      handleSlideBtnShow() {
        this.isShowSlide = this.typeTabDom2.clientWidth - this.typeTabDom2.parentNode.clientWidth > 0;
        if (this.isShowSlide) {
          this.$nextTick(() => {
            this.typeTabDomMoveMax = this.typeTabDom.clientWidth - this.typeTabDom.parentNode.clientWidth;
          });
        }
      },
      // 生成美容项目列表
      async handleSlideList() {
        this.typeTabList = this.commonData.cosmetologyTree;
        if (this.hairdressingInfoData.selectedTypeTabData) {
          this.hairdressingInfoData.selectedTypeTabData.isActive = false;
          this.hairdressingInfoData.selectedTypeTabData = null;
        }
        this.refreshControl = false;
        // 刷新显示
        await this.$nextTick(() => {
          this.refreshControl = true;
          this.handleSlideBtnShow();
        })
        // console.log("CommonHairessingInfo handleSlideList, typeTabList:", this.typeTabList);     
  
      },
      // 判断参数编号是否需要滚动
      handleParNumsSlideBtnShow() {

        this.isShowParNumsBtn = this.parNumsDom2.clientWidth - this.parNumsDom.clientWidth > 0;
        // 算出参数编号dom可以滑动的距离
        if (this.isShowParNumsBtn) {
          this.$nextTick(() => {

            this.parNumsDomMoveMax = this.parNumsDom4.clientWidth - this.parNumsDom3.clientWidth;
          });

        }
      },
      // 生成一个参数为空的参数编号
      async createEmptyParNum(numText) {

        if (this.hairdressingInfoData.selectedParNum) {
          this.hairdressingInfoData.selectedParNum.isActive = false;
        }
        let addOrSplice = true;

        for(let i = 0;i<this.parNumsList.length;i++){
          let item = this.parNumsList[i];

          if (item.number === numText){
            this.parNumsList.splice(i,1,{
              number: numText,
              isActive: true,
            })
            addOrSplice = false;
            break;
          }
        }
       
        if (addOrSplice){
          this.parNumsList.push({
            number: numText,
            isActive: true,
          });
        }
        
     
        this.hairdressingInfoData.selectedParNum = this.parNumsList[this.parNumsList.length - 1];
        // 刷新显示
        this.refreshParNumsShow();
        await this.handleSlideList();
        // 取消显示详细信息
        if (this.hairdressingInfoData.selectedTypeTabData) {
          this.hairdressingInfoData.selectedTypeTabData.isActive = false;
          this.hairdressingInfoData.selectedTypeTabData = null;
        }
    
        if  (this.typeTabList.length>0){
    
          this.commonData.isClickAddSign = false ;
          if (this.hairdressingInfoData.selectedTypeTabData) {
            this.hairdressingInfoData.selectedTypeTabData.isActive = false;
          }
          this.typeTabList[0].isActive = true;
          this.hairdressingInfoData.selectedTypeTabData = this.typeTabList[0];
          this.$root.$emit('selectTypeTab');
        }


      },
      // 双击参数编号显示弹框
      modifyParNum() {
        this.modifyParNumData.isShowDialog = true;
      },
      // 点击添加参数编号按钮
      addParNum() {
        if (this.commonData.patientId === -1) {
          this.$message.error('请添加患者信息');
          return;
        }
        if (this.commonData.treat_no === '') {
          this.$message.error('请添加相关信息');
          return;
        }
        this.addParNumData.isShowDialog = true;
      },
      // 刷新参数编号列表显示
      async refreshParNumsShow() {
    

        this.isShowParNumsBtn = false;
        await this.$nextTick(() => {

          this.handleParNumsSlideBtnShow();
        });

      },
      // 查询并生成参数编号数据
      async getParNums() {
        try {
          const res = await this.$apollo.query({
            query: gql`query(
              $patient_id: Int!
              $treat_no: String!
            ){
              getCosmetologyReleInfo(
                patient_id: $patient_id
                treat_no: $treat_no
              ){
                id
                treat_details{
                  id
                  item_id
                  device_id
                  module_id
                  param_value
                  detail_title
                }
              }
            }`,
            fetchPolicy: "no-cache",
            variables: {
              patient_id: this.commonData.patientId,
              treat_no: this.commonData.treat_no,
            },
          });
          const parNumsArr = res.data.getCosmetologyReleInfo.treat_details;

          if (parNumsArr.length) {
            for (const item of parNumsArr) {
              item.number = item.detail_title;
              item.isActive = false;
            }
            parNumsArr[0].isActive = true;
            this.parNumsList = parNumsArr;
          } else {
            
            this.parNumsList = [{
              number: '1',
              isActive: true,
            }];
          }

          this.hairdressingInfoData.selectedParNum = this.parNumsList[0];
          // 刷新显示
          await this.refreshParNumsShow();
          await this.handleSlideList();
          // 显示参数详情          
          this.showParNumDetail(this.parNumsList[0]);
          // console.log("In CommonHairdressingInfo, getParNums(), parNumsList:",this.parNumsList);
          // console.log("selectedParNum:",this.hairdressingInfoData.selectedParNum);
        } catch (error) {
          this.$message.error(error.message.split(":")[1]);
        }
      },

      // 快捷搜索关键字
      queryItem(queryString, cb) {
        let fullItemInfo = [];
        let seperator = this.seperator;
        for(let i = 0; i < this.typeTabList.length; i++){
          let itemName = this.typeTabList[i].item_name
          let devices = this.typeTabList[i].device
          for(let j = 0; j < devices.length; j++){
            let deviceName = devices[j].device_name
            let treatModules = devices[j].treat_module
            for(let k = 0; k < treatModules.length; k++){
              let treatModuleName = treatModules[k].module_name
              let itemId = treatModules[k].item_id
              let deviceId = treatModules[k].device_id
              let moduleId = treatModules[k].id
              let params = treatModules[k].params
              let newItem = itemName + seperator + deviceName + seperator + treatModuleName
              let newId = itemId + seperator + deviceId +  seperator + moduleId
              fullItemInfo.push({
                id: newId,
                value: newItem, 
                params: params,              
              })
            }
          }
        }
        // console.log("fullItemInfo:",fullItemInfo);
        const arr = [];
        for(let i = 0; i < fullItemInfo.length; i++){
          let queryRes = PinyinMatch.match(fullItemInfo[i].value, queryString)
          if(queryRes){
              arr.push(fullItemInfo[i])
          }
        }
        // console.log("Matched queryRes:",arr);
        cb(arr);
      },
      
      // 选择快捷搜索结果中的一项
      selectItem(item) {
        this.haveSelectedItem = true;
        let seperator = this.seperator;
        let tmpIdArr = item.id.split(seperator); // "item_id--device_id--module_id"
        let item_id = tmpIdArr[0];
        let tmpNameArr = item.value.split(seperator); // "item_name--device_name--module_name"
        let quickSelectedItem = {
          item_id: parseInt(item_id),
          device_id: parseInt(tmpIdArr[1]),
          module_id: parseInt(tmpIdArr[2]),
          item_name: tmpNameArr[0],
          device_name: tmpNameArr[1],
          module_name: tmpNameArr[2],   
          params: item.params,       
        };
        // 设置quickSelectedItem后，传参数给子组件commonHairdressingForm
        this.hairdressingInfoData.quickSelectedItem = quickSelectedItem;
        // 设置Tab的激活状态
        for(let item of this.typeTabList){
          // console.log(item.id, item_id);
          if((item.id+'') === item_id){
            item.isActive = true;
            this.hairdressingInfoData.selectedTypeTabData = item;
          }else{
            item.isActive = false;
          }
        }

        // console.log("quickSelectedItem:",quickSelectedItem, ", emit quickSelectedItem.");
        // 传参数给子组件commonHairdressingForm
        this.$root.$emit('quickSelectedItem');
      },

      // 保存，暂无效
      saveQuickSelection(bool, ID, showTop1) {
        // 防止blur事件和selectItem重复触发本事件函数
        // if (this.isTrigger) {
        //   return
        // }
        // this.isTrigger = true;
        // if (this.quickSelectedItem === '') {
        //   // 恢复状态
        //   this.isTrigger = false;
        //   return
        // }
      },
      


    },
    
    async mounted() {
      
      this.$root.$on('add-par-num', (numText) => {
        this.createEmptyParNum(numText);
      });
      this.$root.$on('refresh-par-num-list', () => {
        if (this.commonData.patientId > -1 && this.commonData.treat_no) {
          this.getParNums();
        }
      });
      
      this.parNumsDom = this.$refs.numbersContent;
      this.parNumsDom2 = this.$refs.numbersBox;
      this.parNumsDom3 = this.$refs.numItemWrap;
      this.parNumsDom4 = this.$refs.numItemBox;
      this.typeTabDom = this.$refs.tabContent;
      this.typeTabDom2 = this.$refs.tabContent2;
      this.handleSlideBtnShow();
      document.onmouseup = () => {
        clearInterval(this.timer);
        clearInterval(this.timer2);
      };
      // 如果是点击编辑跳转过来
      if (this.$store.state.modifyCosmetologyData.status) {
        this.$store.commit('addModifyCosmetologyStatusCount');
        const timer = setInterval(() => {
          if (this.commonData.patientId > -1 && this.commonData.treat_no) {
    
            clearInterval(timer);
            this.getParNums();
          }
        }, 200);
      }
    
    },
    
    beforeDestroy() {
      this.$root.$off('add-par-num');
      this.$root.$off('refresh-par-num-list');
    }
  
  }
</script>

<style lang="less" scoped>
  .hairdressing-info-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-bottom: 20px;
    box-sizing: border-box;
    
    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #48a3c2;
      font-size: 16px;
      border-bottom: 2px solid #48a3c2;
      background-color: #fff;
      padding: 5px;
      padding-bottom: 10px;
      overflow: hidden;
      height: 30px;
      text-align: left;
      
      .btn-wrap {
        display: flex;
      }
    }
    .parameter-number{
      display: flex;
      align-items: center;
      height: 46px;
      padding: 0 17px 0 20px;
      background-color: rgb(159,201,224);
      box-shadow: 0 2px 3px #909090;
      .text{
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        font-size: 15px;
      }
      .numbers-content{
        display: flex;
        flex: 1;
        height: 100%;
        overflow: hidden;
        .numbers-box{
          position: relative;
          display: flex;
          align-items: center;
          height: 100%;
          padding-left: 28px;
          padding-right: 5px;
          .to-left-btn{
            position: absolute;
            left: 5px;
            top: 0;
            width: 20px;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
            cursor: pointer;
            user-select: none;
          }
          .to-left-btn:active{
            color: rgb(187, 187, 187);
          }
          .to-right-btn{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 20px;
            height: 100%;
            color: #ffffff;
            margin-right: 6px;
            cursor: pointer;
            user-select: none;
          }
          .to-right-btn:active{
            color: rgb(187, 187, 187);
          }
          .num-item-wrap{
            position: relative;
            height: 100%;
            .num-item-box{
              display: flex;
              align-items: center;
              height: 100%;
              .num-item{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 28px;
                height: 28px;
                background-color: rgb(235,235,235);
                border-radius: 5px;
                border: 1px solid rgb(72, 151, 199);
                box-sizing: border-box;
                cursor: pointer;
                user-select: none;
              }
              .num-item + .num-item{
                margin-left: 6px;
              }
              .num-item:last-child{
                margin-right: 3px;
              }
              .num-item.active{
                cursor: default;
                color: #ffffff;
                transform: scale(1.1);
                background-color: #f00;
              }
            }
          }
          .add-btn{
            display: flex;
            justify-content: center;
            align-items: center;
            width: 28px;
            height: 28px;
            color: #ffffff;
            background-color: #e9af3f;
            border-radius: 5px;
            box-shadow: 2px 2px 3px #909090;
            cursor: pointer;
            user-select: none;
            font-size: 20px;
            font-weight: normal;
          }
        }
        .numbers-box.showSlide{
          flex: 1;
          overflow: hidden;
          .num-item-wrap{
            flex: 1;
            overflow: hidden;
            .num-item-box{
              position: absolute;
              left: 0;
              top: 0;
            }
          }
        }
      }
    }
    .type-tab-wrap{
      position: relative;
      height: 44px;
      .type-tab{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        height: 44px;
        background-color: #fff;
        .slide-btn{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 40px;
          box-sizing: border-box;
          color: #9FC8E3;
          background-color: #F1F2F8;
          /*border-left: 1px solid #9FC8E3;*/
          /*border-right: 1px solid #9FC8E3;*/
          border-bottom: 1px solid #e0e0e0;
          user-select: none;
        }
        .slide-btn:active{
          color: #fff;
          background-color: #e4ecf8;
        }
        .center-box{
          position: relative;
          flex: 1;
          overflow: hidden;
          .tab-content{
            position: absolute;
            top: 0;
            display: flex;
            height: 100%;
            width: max-content;
            .tab-item{
              float: left;
              display: flex;
              justify-content: center;
              align-items: center;
              min-width: 130px;
              height: 100%;
              padding: 0 15px;
              box-sizing: border-box;
              background-color: #EBEBEB;
              border-bottom: 1px solid #e0e0e0;
              user-select: none;
              cursor: pointer;
            }
            .tab-item + .tab-item{
              border-left: 2px solid #ccc;
            }
            .tab-item.active{
              background-color: #EFF2F7;
              border-bottom-color: #EFF2F7;
            }
            .tab-item.disabled{
              cursor: default;
            }
          }
        }
      }
      .type-tab.on{
        z-index: 1;
      }
    }
    
    .content {
      display: flex;
      flex: 1;
      box-shadow: 0 4px 3px #909090;
      background-color: #EFF2F7;
      padding: 15px 10px;
      overflow-y: auto;
    }

    .quickSearch {
      width: 100%;
      height: 40px;
      flex-direction: column;
      align-items: flex-start;
      // border: 1px solid #61a2bf;
      // padding: 10px;
      font-size: 16px;
      // color: #61a2bf;
      background-color: #EFF2F7;
      border-radius: 6px;
      margin-top: 6px;
      margin-bottom: 6px;
      // margin-right: 1%;
      
      .quickSearchLine {
        width: 60%;
        display: flex;
        flex-direction: row;
        align-items: center;
        
        .inline-input {
          ::-webkit-input-placeholder {
            text-align: center;
          }
        }
      }
    }
  }
</style>
